import moment from "moment";

export default class MiscUtils {
  static saveScrollYPosition = () => {
    sessionStorage.setItem("scrollYPosition", window.scrollY);
  };

  static checkIfValidEmail = (email) => {
    const emailRegex =
      /^[_A-Za-z0-9-+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/;
    if (!emailRegex.test(email)) {
      return false;
    }
    return true;
  };

  static checkIfIntegerInput = (value) => {
    const integerRegex = /^[0-9]*$/;
    if (!integerRegex.test(value)) {
      return false;
    }
    return true;
  };

  static convertToPercentage = (num1, num2) => {
    return ((Math.abs(num1) / Math.abs(num2)) * 100).toFixed(0);
  };

  //This is for in case the date in format of 2024-09-11T12:56:58.833368, it will return date in the given format
  static getDateInFormat = (dateString, format) => {
    if (dateString) {
      const parsedDate = moment(dateString);
      return parsedDate.format(format);
    }
    return "";
  };

  static getUrlExtension(url) {
    return url.split(/[#?]/)[0].split(".").pop().trim();
  }

  static getFileName(url) {
    const fileName = url.split("/").pop();
    return fileName.substr(0, fileName.lastIndexOf("."));
  }

  static getFileNameWithExtension(url) {
    return url.split("/").pop();
  }

  static checkIfImageUrl(url) {
    return url.match(/\.(jpeg|jpg|png|gif)$/) !== null;
  }
}
